import { render } from "./ClientPayment.vue?vue&type=template&id=62b68770&scoped=true"
import script from "./ClientPayment.vue?vue&type=script&lang=js"
export * from "./ClientPayment.vue?vue&type=script&lang=js"

import "./ClientPayment.vue?vue&type=style&index=0&id=62b68770&scoped=true&lang=scss"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b68770"]])

export default __exports__